<template>
  <div>
    <Page :total="data.pageTotal"
          :current="data.page"
          :page-size="data.pageSize"
          show-elevator
          show-sizer
          show-total
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"></Page>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        page: {
          type: Number,
          default: 1
        },
        pageSize: {
          type: Number,
          default: 10
        },
        pageTotal: {
          type: Number,
        }
      }
    },
    name: "page",
    methods: {
        pageChange(val) {
          console.log(1);
          this.data.page = val;
          this.$emit('pageChange', val, this.data.pageSize);
        },
        pageSizeChange(val) {
          console.log(2);
          this.data.pageSize = val;
          this.$store.commit('updatePageSize',val);
          localStorage.pageSize = val;
          if (this.data.page == 1) {
            this.$emit('pageChange', this.data.page, val);
          }
        }
      },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/page.vue